import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_IAP_NOTIFICATION_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_IAP_NOTIFICATION_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_IAP_NOTIFICATION_DETAIL_API_ID,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/iap-notifications/${id}`,
    method: 'GET',
  })
);

export default apiCall;
